<ng-template #historicoEstados>
    <div class="row justify-content-center">
        <div class="col-md-10 bg-white p-2">
            <!-- titulo -->
            <h4>Historico estados</h4>

            <!-- contenido -->
            <div>
                <div class="col-sm-12 table-responsive">
                    <dx-data-grid id="gridContainer" [dataSource]="registrosHistorial" [showBorders]="true" [columnAutoWidth]="true">
                        <dxo-paging [pageSize]="10"></dxo-paging>
                        <dxo-pager [visible]="true"  [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20]" [showInfo]="true">
                        </dxo-pager>
                        <dxi-column dataField="descripcionEstado"></dxi-column>
                        <dxi-column dataField="usuario"></dxi-column>
                        <dxi-column dataField="fecha" dataType="date" format="dd/MM/yyyy HH:mm:ss"></dxi-column>
                        <dxi-column dataField="observacionEstado"></dxi-column>
                        
                    </dx-data-grid>
                </div>
            </div>

            <!-- botones -->
            <div class="mt-1">
                <button type="button" class="btn btn-danger" (click)="descartar()">Cerrar</button>
            </div>
        </div>
    </div>
</ng-template>

<button type="button" class="btn btn-secondary" (click)="abrirHistoricoEstados(historicoEstados)" >
    <!-- Historico -->
    <span>
        Historial estados
    </span>
</button>

